export interface GlossaryLink {
  label: string
  href: string
}

export interface GlossaryEntry {
  id: string
  term: string
  short: string
  long?: string
  links?: GlossaryLink[]
}

export const GLOSSARY: GlossaryEntry[] = [
  {
    id: 'iyi-huylu-kotu-huylu',
    term: 'iyi huylu ve kötü huylu',
    short:
      'İyi huylu (benign) lezyonlar kanser değildir, çevre dokuya yayılmaz. Kötü huylu (malign) lezyonlar kanser hücreleri içerir ve yayılma riski taşır.',
    long:
      'Tıbbi terminolojide "benign" ve "malign" sıkça kullanılsa da bu sayfalarda Türkçe karşılıkları olan "iyi huylu" ve "kötü huylu" tercih edilmiştir. Sezi, bir lezyonun bu iki sınıftan hangisine ait olma olasılığını tahmin eder. Tahmin bir olasılık değeridir, kesin tanı değildir.',
  },
  {
    id: 'auc',
    term: 'AUC',
    short:
      'AUC, modelin iyi ve kötü huyluyu birbirinden ayırt etme başarısının 0 ile 1 arasında bir ölçüsüdür. 1.0 mükemmel, 0.5 ise rastgele tahmin demektir.',
    long:
      'AUC (Area Under the ROC Curve, ROC eğrisi altındaki alan) modelin sınıflandırma başarısını farklı eşik değerlerinde değerlendirir. Bu projedeki sonuçlar 5 farklı veri bölümünde eğitilmiş modellerin ortalamasıdır; her sayının bir hata payı vardır.',
    links: [
      { label: 'ROC eğrisi (Wikipedia)', href: 'https://tr.wikipedia.org/wiki/Al%C4%B1c%C4%B1_%C3%A7al%C4%B1%C5%9Fma_karakteristi%C4%9Fi' },
    ],
  },
  {
    id: 'pooled-auc',
    term: 'havuzlanmış AUC (pooled AUC)',
    short:
      'Tüm çapraz doğrulama bölmelerinden gelen tahminleri tek bir havuzda toplayıp tek bir AUC hesaplamasına havuzlanmış AUC denir.',
    long:
      'Kat ortalaması AUC, her kat için ayrı AUC hesaplayıp ortalar. Havuzlanmış AUC ise tüm tahminleri birleştirip bir kez hesaplar. İki sayı arasındaki büyük fark, modelin katlar arasında ölçek farkı (kalibrasyon kayması) olduğuna işaret eder.',
  },
  {
    id: 'brier',
    term: 'Brier skoru',
    short:
      'Modelin ürettiği olasılık ile gerçek etiket arasındaki ortalama karesel farktır. 0.0 mükemmel, 0.25 rastgele tahmin (sınıf %50/50 ise) demektir. Düşük olması iyidir.',
    long:
      'Brier skoru hem sıralama doğruluğunu hem de mutlak olasılık kalibrasyonunu birlikte ölçer. AUC sıralama doğruluğuna duyarlıyken, Brier skoru "tahmin %70 ise gerçekten %70 olmalı" türünde mutlak doğruluğa da duyarlıdır.',
  },
  {
    id: 'dice',
    term: 'Dice skoru',
    short:
      'İki bölgenin (örneğin tahmin ve gerçek lezyon maskesinin) örtüşme oranını ölçen 0 ile 1 arası bir metriktir. 1.0 mükemmel örtüşme, 0.0 hiç örtüşme yok demektir.',
    long:
      'Segmentasyon başarısı için en yaygın kullanılan ölçüttür. Sezi’de segmentasyon modelinin Dice skorları kohorta göre 0.57 ile 0.82 arasında değişir.',
    links: [
      { label: 'Sørensen-Dice katsayısı (Wikipedia)', href: 'https://en.wikipedia.org/wiki/Sørensen–Dice_coefficient' },
    ],
  },
  {
    id: 'voksel',
    term: 'voksel',
    short:
      'İki boyutlu pikselin üç boyutlu karşılığıdır. Tomografik bir görüntüde her voksel uzayda küçük bir küp hacmi temsil eder.',
    long:
      'Sezi’de yeniden örnekleme sonrası vokseller yaklaşık 1.20 × 0.703 × 0.703 milimetre büyüklüğündedir. Lezyon segmentasyonu, hangi vokselin lezyona ait olduğuna voksel voksel karar verir.',
  },
  {
    id: 'kohort',
    term: 'kohort',
    short:
      'Aynı hastane veya araştırma çalışmasından, benzer protokollerle toplanmış hasta görüntülerinin oluşturduğu gruba kohort denir.',
    long:
      'Bu projede iki kohort kullanılmıştır: AMBL ve BREAST-DIAGNOSIS. Farklı kohortlar farklı MR cihazları, farklı çekim protokolleri ve farklı hasta dağılımları içerebilir. Bu farklılıklar modelin başarısını doğrudan etkiler.',
    links: [
      { label: 'AMBL veri kümesi (TCIA)', href: 'https://www.cancerimagingarchive.net/collection/advanced-mri-breast-lesions/' },
      { label: 'BREAST-DIAGNOSIS veri kümesi (TCIA)', href: 'https://www.cancerimagingarchive.net/collection/breast-diagnosis/' },
    ],
  },
  {
    id: 'capraz-dogrulama',
    term: 'çapraz doğrulama',
    short:
      'Veri kümesini birden çok parçaya bölüp her parçayı sırayla test verisi olarak kullanma yöntemine çapraz doğrulama denir. Modelin gerçek performansını daha güvenilir ölçer.',
    long:
      '5 katlı çapraz doğrulamada veri 5 parçaya bölünür ve 5 farklı model eğitilir. Her model 5 parçanın 4’ünü eğitim, 1’ini test için kullanır. Sezi’nin sınıflandırma sonuçları bu 5 modelin tahminlerinden gelir. Bu parçalara teknik metinlerde bazen "fold" da denir.',
    links: [
      { label: 'Çapraz doğrulama (Wikipedia)', href: 'https://en.wikipedia.org/wiki/Cross-validation_(statistics)' },
    ],
  },
  {
    id: 'topluluk',
    term: 'topluluk (ensemble)',
    short:
      'Birden çok modelin tahmininin ortalaması alınarak tek bir sonuç üretmesine topluluk yöntemi denir. Genellikle tek modelden daha tutarlı sonuç verir.',
    long:
      'Sezi’de bu, 5 çapraz doğrulama modelinin tahminlerinin ortalanması anlamına gelir. Modelin eğitimde hiç görmediği bir kohorta uygulanırken topluluk yöntemi kullanılır.',
  },
  {
    id: 'tta',
    term: 'test zamanı artırma (TTA)',
    short:
      'Modelin aynı görüntü üzerinde farklı yansıma ve döndürme varyantlarıyla tahmin yapıp ortalamayı alması yöntemine test zamanı artırma denir. Tek tahminden daha kararlı bir sonuç verir.',
    long:
      'Sezi, sınıflandırma sırasında görüntünün dört farklı yansıma varyantını kullanır. Bu varyantların tahminlerinin ortalaması alınır. Tipik olarak küçük ama tutarlı bir doğruluk artışı sağlar.',
  },
  {
    id: 'alan-kaymasi',
    term: 'alan kayması (domain shift)',
    short:
      'Modelin eğitildiği veriden farklı bir kaynaktaki veriye uygulandığında performansının düşmesine alan kayması denir.',
    long:
      'Bu projede AMBL üzerinde eğitilmiş modelin BREAST-DIAGNOSIS üzerinde performansının belirgin biçimde düştüğü gözlemlenmiştir. Bu, MR cihazı ayarları, kontrast protokolü ve hasta popülasyonu farklılıklarından kaynaklanır.',
  },
  {
    id: 'segmentasyon',
    term: 'segmentasyon',
    short:
      'Görüntüde lezyonun tam sınırlarını voksel voksel işaretleme işlemine segmentasyon denir.',
    long:
      'Sezi’nin segmentasyon adımı nnU-Net tabanlı bir derin öğrenme modeli kullanır. Sonuç bir maske görüntüsüdür; her voksel ya lezyon ya da arka plan olarak etiketlenir.',
    links: [
      { label: 'nnU-Net (GitHub)', href: 'https://github.com/MIC-DKFZ/nnUNet' },
    ],
  },
  {
    id: 'on-egitim',
    term: 'ön eğitim (pre-training)',
    short:
      'Bir modelin önce büyük bir veri kümesinde genel desenleri öğrenmesi, sonra küçük bir veri kümesinde son göreve uyarlanması sürecine ön eğitim denir.',
    long:
      'Sezi’nin segmentasyon modeli yaklaşık 1500 hastalık MAMA-MIA koleksiyonunda ön eğitilmiştir. Sınıflandırıcının kodlayıcı katmanları bu ön eğitimden başlatılır ve küçük olan AMBL kümesinde ince ayar yapılır. Bu sayede sınıflandırıcı, derin öğrenme için küçük sayılan bir veri kümesinde de iş görür.',
  },
  {
    id: 'kinetik-kanal',
    term: 'kinetik kanal',
    short:
      'Lezyonun kontrast madde sonrasındaki zaman içindeki yoğunluk değişimini sayısal kanallar olarak ifade eden öznitelik kümesidir.',
    long:
      'Kötü huylu lezyonlar kontrast maddeyi farklı bir hızla alıp boşaltır. Kinetik kanallar bu davranışı modele girdi olarak verir; örneğin "kontrast sonrası en yüksek değer ile öncesi arasındaki fark" gibi.',
  },
  {
    id: 'kontrast-alimi',
    term: 'kontrast alımı ve boşalımı (wash-in / wash-out)',
    short:
      'Kontrast maddenin damardan verilmesinden sonra dokunun yoğunluğunun yükselmesine kontrast alımı, daha sonra düşmesine kontrast boşalımı denir.',
    long:
      'Lezyonların iyi/kötü huylu ayrımında bu zaman eğrisinin şekli önemlidir. Kötü huylu lezyonlarda yoğunluk hızla yükselir ve hızla düşerken, iyi huylu lezyonlarda eğri daha yavaş bir tepe çizer. Sezi bu davranışı kinetik kanallar üzerinden modele girdi olarak verir.',
  },
  {
    id: 'taubin',
    term: 'Taubin yumuşatma',
    short:
      '3 boyutlu yüzeyleri hacmini bozmadan pürüzsüzleştiren bir filtreleme yöntemidir.',
    long:
      'Voksel ızgarasından elde edilen 3B model genelde köşeli ve düzensiz olur. Taubin yumuşatma, lezyonun gerçek hacmini koruyarak görsel olarak daha temiz bir yüzey üretir.',
    links: [
      { label: 'trimesh kütüphanesi', href: 'https://github.com/mikedh/trimesh' },
    ],
  },
  {
    id: 'mars-kupleri',
    term: 'yürüyen küpler (marching cubes)',
    short:
      '3 boyutlu bir voksel ızgarasından yüzey çıkaran klasik bir algoritmadır. Sezi, segmentasyon maskesini bu yöntemle 3B yüzey ağına dönüştürür.',
    long:
      'Algoritma, ızgarayı küçük küplere ayırır. Her küpün köşelerinde lezyon var/yok bilgisine bakarak küp içinden geçen yüzey parçalarını üretir. Sonuç, üçgenlerden oluşan kapalı bir yüzey ağıdır.',
    links: [
      { label: 'Marching cubes (Wikipedia)', href: 'https://en.wikipedia.org/wiki/Marching_cubes' },
      { label: 'scikit-image gerçeklemesi', href: 'https://scikit-image.org/docs/stable/api/skimage.measure.html#skimage.measure.marching_cubes' },
    ],
  },
  {
    id: 'ras',
    term: 'RAS yönlendirmesi',
    short:
      'Anatomik eksenlerin standart bir düzene oturtulmasıdır: sağ (Right), ön (Anterior), üst (Superior). Farklı cihazlardan gelen görüntüleri aynı koordinat sistemine taşır.',
    long:
      'MR cihazları görüntüleri farklı eksen sıralarıyla kaydedebilir. RAS yönlendirmesi, modelin her zaman aynı anatomik düzenle çalışmasını sağlar; aksi halde sol-sağ veya yukarı-aşağı eksenleri kaymış görüntüler model için farklı görünür.',
  },
  {
    id: 'multifokal',
    term: 'multifokal',
    short:
      'Aynı memede birden çok ayrı odakta görülen lezyonları tanımlayan radyolojik terimdir.',
  },
  {
    id: 'dce-mri',
    term: 'DCE-MRI',
    short:
      'Kontrastlı meme MR (Dynamic Contrast-Enhanced MRI). Damardan kontrast madde verildikten sonra ardışık zamanlarda çekilen MR serisidir; lezyonların kontrast tutuş davranışı hakkında bilgi sağlar.',
  },
  {
    id: 'dicom',
    term: 'DICOM',
    short:
      'Tıbbi görüntülerin (MR, BT, ultrason) cihazlardan paylaşılırken kullanılan standart dosya biçimidir. Görüntü pikselleri ile birlikte hasta ve çekim bilgilerini de taşır.',
    links: [
      { label: 'DICOM standardı', href: 'https://www.dicomstandard.org/' },
    ],
  },
  {
    id: 'nifti',
    term: 'NIfTI',
    short:
      'Bilimsel beyin ve tıbbi görüntü analizinde yaygın kullanılan, 3 boyutlu hacimleri tek dosyada saklayan biçimdir (.nii veya sıkıştırılmış .nii.gz).',
  },
  {
    id: 'gltf',
    term: 'glTF',
    short:
      'Tarayıcılar ve 3B oyunlar için optimize edilmiş bir 3 boyutlu model paylaşım biçimidir. Sezi, lezyonun yüzey ağını glTF olarak yayınlar (.glb dosyası).',
    links: [
      { label: 'glTF standardı', href: 'https://www.khronos.org/gltf/' },
    ],
  },
  {
    id: 'mama-mia',
    term: 'MAMA-MIA veri kümesi',
    short:
      'Yaklaşık 1500 hastadan oluşan, çok merkezli açık erişimli bir kontrastlı meme MR koleksiyonudur. Sezi’nin segmentasyon modelinin temel ön eğitimini sağlamıştır.',
    links: [
      { label: 'MAMA-MIA (Synapse)', href: 'https://www.synapse.org/Synapse:syn60868042' },
    ],
  },
  {
    id: 'ambl',
    term: 'AMBL veri kümesi',
    short:
      'Advanced-MRI-Breast-Lesions: 99 hastadan toplanmış 165 lezyonluk açık erişimli kontrastlı meme MR koleksiyonu, uzman radyolog çizimli maskelerle. Sınıflandırıcının birincil eğitim kaynağıdır.',
    links: [
      { label: 'AMBL (TCIA)', href: 'https://www.cancerimagingarchive.net/collection/advanced-mri-breast-lesions/' },
    ],
  },
  {
    id: 'bd',
    term: 'BREAST-DIAGNOSIS veri kümesi',
    short:
      '45 hastadan oluşan, hasta başına 8 fazlı kontrastlı meme MR koleksiyonu. Sezi’de kombine modelin eğitiminde ve kohortlar arası testte kullanılır. Lezyon maskeleri Sezi’nin kendi segmentasyon modeli tarafından otomatik üretilmiştir.',
    links: [
      { label: 'BREAST-DIAGNOSIS (TCIA)', href: 'https://www.cancerimagingarchive.net/collection/breast-diagnosis/' },
    ],
  },
]

export function findTerm(id: string): GlossaryEntry | undefined {
  return GLOSSARY.find((t) => t.id === id)
}
